import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import {dataToSupplierMappingsList} from '../parsings'
import { useSearchParams } from 'react-router-dom';
import {useEffect} from 'react'

const useSupplierMappingDetailsList = (setCheckedRows: any) => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const initialFilters = {
    page: 1,
    limit: 30,
    user_email: id || '',
    sort_by: 'modified_at/-1',
    brand: '',
    search: '',
  }
  const Api = useApi()
  const {filters, onSearch, onSortingChange, setMultipleFilters, onPageChange} = useFilters(
    initialFilters,
    {
      sortType: 'number',
    }
  )
  const {data: response, isFetching} = Api.useGetQuery('/suppliers/users/brand/products/mapping', {
    queryId: 'user-supplier-mapping',
    filters: filters,
  })

  useEffect(() => {
    setCheckedRows([])
  }, [filters, setCheckedRows])

  const onBrandFilterChange = (values: any) => {
    setMultipleFilters({brand: values?.map((item: any) => item?.value)?.join(','), page: 1})
  }

  return {
    usersMappingsList: dataToSupplierMappingsList(response?.data || []),
    isLoading: isFetching,
    pagination: response?.meta?.pagination,
    onPageChange,
    filters,
    onSearch,
    onSortingChange,
    onBrandFilterChange,
  }
}

export default useSupplierMappingDetailsList
